import { react2angular } from 'react2angular';

import AppointmentBooking from './AppointmentBooking';

angular
  .module('bb.appointmentbooking', [])
  .component(
    'appointmentBooking',
    react2angular(
      AppointmentBooking,
      [
        'fetchSavedAppointment',
        'extAuth',
        'setExtAuth',
        'appointmentDetails',
        'isListingContact',
        'isDoneWelcomeFlow',
      ],
      [
        '$location',
        '$rootScope',
        '$routeParams',
        '$anchorScroll',
        '$timeout',
        'ErrorService',
        'AppointmentBookService',
        'ListingViewService',
        'ExternalService',
        'AppointmentConfigService',
        'listingNotificationSettings',
        'UtilService',
        'ModalService',
      ],
    ),
  );
